import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_daycare-visit-book/artifacts/hfd2nsp4_Screenshot%202026-03-17%20at%209.00.03%E2%80%AFPM.png";

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white py-16 mt-20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-6">
              <img 
                src={LOGO_URL} 
                alt="Good Hands Family Daycare" 
                className="h-16 w-auto object-contain bg-white rounded-xl p-1"
              />
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Where every child is nurtured with love, care, and attention in a safe family environment.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/programs" 
                  className="text-slate-400 hover:text-yellow-400 transition-colors text-sm"
                  data-testid="footer-link-programs"
                >
                  Our Programs
                </Link>
              </li>
              <li>
                <Link 
                  to="/gallery" 
                  className="text-slate-400 hover:text-yellow-400 transition-colors text-sm"
                  data-testid="footer-link-gallery"
                >
                  Gallery
                </Link>
              </li>
              <li>
                <Link 
                  to="/book-visit" 
                  className="text-slate-400 hover:text-yellow-400 transition-colors text-sm"
                  data-testid="footer-link-book-visit"
                >
                  Book a Visit
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-lg mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-yellow-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-400 text-sm">
                  2689 Travers Place<br />
                  Warrenton, VA 20187
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-yellow-400 flex-shrink-0" />
                <a 
                  href="tel:+15715359999" 
                  className="text-slate-400 hover:text-yellow-400 transition-colors text-sm"
                  data-testid="footer-phone"
                >
                  (571) 535-9999
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-yellow-400 flex-shrink-0" />
                <a 
                  href="mailto:Sophiechiepodeu@gmail.com" 
                  className="text-slate-400 hover:text-yellow-400 transition-colors text-sm"
                  data-testid="footer-email"
                >
                  Sophiechiepodeu@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h3 className="font-bold text-lg mb-6">Hours</h3>
            <div className="flex items-start gap-3">
              <Clock className="w-5 h-5 text-yellow-400 flex-shrink-0 mt-0.5" />
              <div className="text-slate-400 text-sm">
                <p className="font-medium text-white mb-2">Monday - Friday</p>
                <p>7:00 AM - 7:00 PM</p>
                <p className="mt-4 text-xs">
                  Closed on weekends and major holidays
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 text-center">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} Good Hands Family Daycare. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
